module.exports = __webpack_public_path__ + "static/media/3 3 tattoo chest arm samurai sakura irezumi flowing traditional.1280x1889.ec3f4c07.webp";